import { SDK_VERSION } from './version.js';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */
function applySdkMetadata(options, name) {
  var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [name];
  var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'npm';
  var metadata = options._metadata || {};
  if (!metadata.sdk) {
    metadata.sdk = {
      name: "sentry.javascript.".concat(name),
      packages: names.map(function (name) {
        return {
          name: "".concat(source, ":@sentry/").concat(name),
          version: SDK_VERSION
        };
      }),
      version: SDK_VERSION
    };
  }
  options._metadata = metadata;
}
export { applySdkMetadata };